import React from 'react'

const ManualPage: React.FC = () => {
    return (
        <div className="flex flex-row w-[1200px] h-full p-10 rounded-3xl gap-2 ">
            <div className="flex flex-col w-full h-full items-start justify-start text-[#000000] text-[16px] gap-5">
                <div className="flex flex-col w-full gap-5 items-center justify-center bg-[#e4e7ea] p-10 rounded-3xl">
                    <div className="flex w-[800px] items-center justify-center text-center font-semibold">
                        Описание функциональных характеристик программного
                        обеспечения и информация, необходимая для установки и
                        эксплуатации программного обеспечения
                    </div>

                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-col w-[500px] items-center justify-center text-center">
                            <span className="font-bold">
                                «Система автоматизации планирования закупок»
                            </span>{' '}
                            <br />
                            (Инструкция пользователя и администратора)
                        </div>
                        <div className="flex w-[1000px] items-center justify-center">
                            <a
                                className="text-sky-600 hover:text-sky-400"
                                href="/docs/instruction_plan.docx"
                                rel="noopener noreferrer"
                            >
                                instruction_plan.docx
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-col w-[500px] items-center justify-center text-center">
                            <span className="font-bold">
                                «NOXSYS.Performance»
                            </span>{' '}
                            <br /> (Инструкция пользователя и администратора)
                        </div>
                        <div className="flex w-[1000px] items-center justify-center">
                            <a
                                className="text-sky-600 hover:text-sky-400"
                                href="/docs/instruction_performance.docx"
                                rel="noopener noreferrer"
                            >
                                instruction_performance.docx
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-col w-[500px] items-center justify-center text-center">
                            <span className="font-bold">«NOXSYS.Contract</span>{' '}
                            <br /> (Инструкция пользователя и администратора)
                        </div>
                        <div className="flex w-[1000px] items-center justify-center">
                            <a
                                className="text-sky-600 hover:text-sky-400"
                                href="/docs/instruction_contract.docx"
                                rel="noopener noreferrer"
                            >
                                instruction_contract.docx
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-col w-[500px] items-center justify-center text-center">
                            <span className="font-bold">«NOXSYS.Tender</span>{' '}
                            <br /> (Инструкция пользователя и администратора)
                        </div>
                        <div className="flex w-[1000px] items-center justify-center">
                            <a
                                className="text-sky-600 hover:text-sky-400"
                                href="/docs/instruction_tender.docx"
                                rel="noopener noreferrer"
                            >
                                instruction_tender.docx
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManualPage
